import { Valuation } from '../../../../shared/state/instruments/instrument.model';

export interface KpiCurrent {
    date: string;
    marketValue: number;
    acquisitionValue: number;
    cumulativeRealizedPnl?: number;
    cumulativeUnrealizedPnl?: number;
    returnInception?: number;
    returnInceptionAnnualized?: number;
    numberOfAssets?: number;
    portfolioCcy?: string;
}

const today = new Date();
export const kpiInitialState: KpiCurrent = {
    date: today.toISOString().split('T')[0],
    marketValue: 0.0,
    acquisitionValue: 0.0,
    cumulativeRealizedPnl: 0.0,
    cumulativeUnrealizedPnl: 0.0,
    returnInception: 0.0,
    numberOfAssets: 0,
    portfolioCcy: ''
};

export interface AssetAllocation {
    type: string;
    acquisitionValuePortfolioCcy?: number;
    numberOfAssets?: number;
    marketValuePortfolioCcy?: number;
    allocation: number;
    name: string;
    '1y'?: number;
}

export const defaultAllocationArt = {
    type: 'ART',
    acquisitionValuePortfolioCcy: 0.0,
    numberOfAssets: 0,
    marketValuePortfolioCcy: 0.0,
    allocation: 0.0,
    name: 'Art',
    '1y': 0.0
};

export const defaultAllocationJewelry = {
    type: 'JEWELRY',
    acquisitionValuePortfolioCcy: 0.0,
    numberOfAssets: 0,
    marketValuePortfolioCcy: 0.0,
    allocation: 0.0,
    name: 'Jewelry',
    '1y': 0.0
};

export const defaultAllocationOther = {
    type: 'OTHER',
    acquisitionValuePortfolioCcy: 0.0,
    numberOfAssets: 0,
    marketValuePortfolioCcy: 0.0,
    allocation: 0.0,
    name: 'Other',
    '1y': 0.0
};

export const defaultAllocationRealEstate = {
    type: 'REAL_ESTATE',
    acquisitionValuePortfolioCcy: 0.0,
    numberOfAssets: 0,
    marketValuePortfolioCcy: 0.0,
    allocation: 0.0,
    name: 'Real Estate',
    '1y': 0.0
};

export const defaultAllocationVehicle = {
    type: 'VEHICLE',
    acquisitionValuePortfolioCcy: 0.0,
    numberOfAssets: 0,
    marketValuePortfolioCcy: 0.0,
    allocation: 0.0,
    name: 'Vehicle',
    '1y': 0.0
};

export interface PortfolioCcy {
    currency: string;
    acquisitionValue: number;
    soldPrice?: number;
    marketValues?: Valuation[];
}

export interface PrivateAsset {
    instrumentId: number;
    name: string;
    portfolio?: string;
    type: string;
    currency: string;
    acquisitionDate: string;
    acquisitionValue: number;
    marketValues: Valuation[];
    comment?: string;
    meta?: any;
    moic?: number;
    base64img?: string;
    deleted?: boolean;
    sold?: boolean;
    soldDate?: string;
    soldPrice?: number;
    soldCcy?: string;
    portfolioCcy?: PortfolioCcy;
}

export interface SellAsset {
    instrumentId: number;
    transactionDate: string;
    price: number;
    currency: string;
    privateAssetType: string;
}

export function getLastMarketValue(marketValues: Valuation[]): Valuation | undefined {
    if (marketValues && marketValues.length > 0) {
        return marketValues.reduce((acc, next) => {
            const date1 = new Date(acc.date);
            const date2 = new Date(next.date);
            return date1.getTime() >= date2.getTime() ? acc : next;
        });
    }
    return undefined;
}
